/**
 * BE BOLD : Path A: Strengthen and Build
 * Month 12: Mastery Foundation (Days 331-365)
 *
 * Integration. Maintenance plan established.
 *
 * All sessions verified at 300s +/-20s (5 minutes)
 * Generated: 2026-04-13 02:14
 *
 * bebold.au | Paula Tomazetti | 16+ years of study
 * All content is 100% Be Bold.
 */

export const exercises = {

  aperto: {
    id: 'aperto',
    name: 'Aperto',
    name_pt: 'Aperto',
    sub: 'Press inward from the sides. Not upward.',
    sub_pt: 'Pressione para dentro dos lados. Não para cima.',
    level: 'Intermediate',
    zone: 'Side walls 0-3cm',
    color: '#A07080',
    movement: 'squeeze',
    inst: `Sit with feet flat on the floor.

Press the left and right walls of the pelvic floor gently toward each other. This is a horizontal movement, not an upward lift. Like pressing the walls of a narrow corridor from both sides.

Hold for the prescribed time. Release completely. The side walls should widen on the release.

Test: do this with your legs apart. If you feel it in your inner thighs, start again.

Picture it: closing elevator doors gently from left and right. Or pressing two book covers together from the sides. The book (your canal) gets narrower.`,
    inst_pt: `Sente com pés apoiados no chão.

Pressione as paredes esquerda e direita do assoalho suavemente uma em direção à outra. Isso é um movimento horizontal, não uma elevação. Como pressionar as paredes de um corredor estreito dos dois lados.

Segure pelo tempo prescrito. Solte completamente. As paredes laterais devem alargar na soltura.

Teste: faça com pernas abertas. Se sentir nas coxas internas, recomece.

Visualize: fechando portas de elevador suavemente da esquerda e direita. Ou pressionando duas capas de livro juntas dos lados. O livro (seu canal) fica mais estreito.`,
    breathe: 'Exhale to press inward. Inhale to release and widen.',
    breathe_pt: 'Expire para pressionar. Inspire para soltar e alargar.',
    timerCue: `Press in.
Hold.
Widen.`,
    timerCue_pt: `Pressione.
Segure.
Alargue.`,
    feel: 'A medial compression of the lateral walls. Distinct from the upward lift.',
    feel_pt: 'Uma compressão medial das paredes laterais. Distinto da elevação para cima.',
    avoid: 'Do not squeeze your inner thighs together. Do not bear down.',
    avoid_pt: 'Não aperte as coxas internas. Não faça força.',
    type: 'hold',
    sets: 10,
    hold: 10,
    relax: 5,
    rest: 0,
  },

  belly_breath_drop: {
    id: 'belly_breath_drop',
    name: 'Belly Breath Drop',
    name_pt: 'Respiro da Barriga',
    sub: 'The floor drops on the inhale. Stay soft on the exhale.',
    sub_pt: 'O assoalho cai na inspiração. Fique macia na expiração.',
    level: 'Release',
    zone: 'Full floor 0-3cm',
    color: '#7A5A6A',
    movement: 'release',
    inst: `Lie on your back with your knees bent and feet flat. Place one hand on your lower belly.

Inhale slowly through your nose for 4 counts. Feel your belly rise under your hand. Your pelvic floor drops gently as your belly expands. You do not push it. It falls on its own.

Exhale through your mouth for 6 counts. Stay soft. Nothing tightens on the exhale. The floor stays dropped.

If you feel nothing at first, that is your starting point.

Picture it: your pelvic floor is a hammock between two trees. Each inhale, the hammock sinks wider. Each exhale, it stays low.`,
    inst_pt: `Deite de costas com os joelhos dobrados e pés apoiados. Coloque uma mão na barriga baixa.

Inspire lentamente pelo nariz por 4 tempos. Sinta a barriga subir sob sua mão. Seu assoalho pélvico desce suavemente conforme a barriga expande. Você não empurra. Ele cai sozinho.

Expire pela boca por 6 tempos. Fique macia. Nada contrai na expiração. O assoalho continua solto.

Se não sentir nada no início, esse é seu ponto de partida.

Visualize: seu assoalho pélvico é uma rede entre duas árvores. Cada inspiração, a rede afunda e alarga. Cada expiração, ela fica baixa.`,
    breathe: 'Inhale 4 counts to drop. Exhale 6 counts to stay soft.',
    breathe_pt: 'Inspire 4 tempos para soltar. Expire 6 tempos para ficar macia.',
    timerCue: `Inhale.
Drop.
Exhale.
Stay soft.`,
    timerCue_pt: `Inspire.
Solte.
Expire.
Fique macia.`,
    feel: 'A subtle widening and heaviness in the pelvic bowl on every inhale. Nothing tense. Nothing forced.',
    feel_pt: 'Uma sutil abertura e peso na pelve a cada inspiração. Nada tenso. Nada forçado.',
    avoid: 'Do not push the floor down. Do not bear down. Do not tighten on the exhale.',
    avoid_pt: 'Não empurre o assoalho para baixo. Não faça força. Não contraia na expiração.',
    type: 'hold',
    sets: 15,
    hold: 4,
    relax: 6,
    rest: 0,
  },

  child_pose_release: {
    id: 'child_pose_release',
    pose: 'child-pose',
    name: 'Child Pose Release',
    name_pt: 'Soltura na Posição Criança',
    sub: 'The deepest passive stretch for a tight floor.',
    sub_pt: 'O alongamento passivo mais profundo para um assoalho tenso.',
    level: 'Release',
    zone: 'Full floor 0-6cm',
    color: '#7A5A6A',
    movement: 'release',
    inst: `Kneel on a soft surface. Bring your knees wide apart. Sit back onto your heels. Stretch your arms forward on the floor.

Let your forehead rest on the floor or on a pillow. Let your belly hang between your thighs.

Inhale for 4 counts. Feel your belly expand toward the floor. Your pelvic floor lengthens between your sit bones.

Exhale for 6 counts. Let everything drop heavier. Gravity pulls your belly down and your floor opens.

Stay here for the full time. No effort. No movement. Just breathing into the stretch.

Picture it: a cat stretching after a nap. Front paws forward, hips back, belly dropped. Total surrender. Or draping a wet towel over a round surface. The towel has no shape of its own. It just falls over whatever is underneath.`,
    inst_pt: `Ajoelhe numa superfície macia. Abra os joelhos bem. Sente nos calcanhares. Estique os braços para frente no chão.

Deixe a testa descansar no chão ou num travesseiro. Deixe a barriga pendurar entre as coxas.

Inspire por 4 tempos. Sinta a barriga expandir em direção ao chão. Seu assoalho pélvico se alonga entre os ísquios.

Expire por 6 tempos. Deixe tudo cair mais pesado. A gravidade puxa a barriga para baixo e seu assoalho abre.

Fique aqui pelo tempo todo. Sem esforço. Sem movimento. Apenas respirando no alongamento.

Visualize: um gato se espreguiçando depois da soneca. Patas dianteiras para frente, quadril para trás, barriga caída. Rendição total. Ou cobrindo uma superfície arredondada com uma toalha molhada. A toalha não tem forma própria. Apenas cai.`,
    breathe: 'Inhale to lengthen. Exhale to surrender.',
    breathe_pt: 'Inspire para alongar. Expire para se render.',
    timerCue: `Inhale.
Lengthen.
Exhale.
Surrender.`,
    timerCue_pt: `Inspire.
Alongue.
Expire.
Rendição.`,
    feel: 'Deep opening across the entire pelvic floor. The belly hangs. The floor stretches.',
    feel_pt: 'Abertura profunda em todo o assoalho pélvico. A barriga pendura. O assoalho se alonga.',
    avoid: 'Do not bear down. If knees hurt, cushion between calves and thighs.',
    avoid_pt: 'Não faça força. Se joelhos doem, almofada entre panturrilhas e coxas.',
    type: 'timed',
    sets: 1,
    hold: 150,
    rest: 0,
  },

  circular_cw: {
    id: 'circular_cw',
    name: 'Circular CW',
    name_pt: 'Circular Horário',
    sub: 'Front-right. Right. Back-right. One direction only.',
    sub_pt: 'Frente-direita. Direita. Trás-direita. Uma direção só.',
    level: 'Advanced',
    zone: 'Full floor 0-3cm',
    color: '#5A3848',
    movement: 'squeeze',
    inst: `Sit with feet flat on the floor.

Gently press the front-right area of the pelvic floor inward for 2 seconds. Release completely.

Move to the right side, press inward for 2 seconds. Release completely.

Move to the back-right, press inward for 2 seconds. Pause. Release completely.

That is one clockwise rotation. Each step must feel like a separate, distinct direction. If the steps feel the same, slow down.

Picture it: moving around a clock face. 2 o'clock, 3 o'clock, 4 o'clock. Each number is a separate press.`,
    inst_pt: `Sente com pés apoiados no chão.

Pressione suavemente a área frente-direita do assoalho por 2 segundos. Solte completamente.

Mova para o lado direito, pressione por 2 segundos. Solte completamente.

Mova para trás-direita, pressione por 2 segundos. Pausa. Solte completamente.

Isso é uma rotação horária. Cada passo deve parecer uma direção separada e distinta. Se os passos parecem iguais, desacelere.

Visualize: movendo ao redor de um relógio. 2 horas, 3 horas, 4 horas. Cada número é uma pressão separada.`,
    breathe: 'Exhale to press each step. Inhale to release between steps.',
    breathe_pt: 'Expire para pressionar cada passo. Inspire para soltar entre passos.',
    timerCue: `Front-right.
Right.
Back-right.
Release.`,
    timerCue_pt: `Frente-dir.
Direita.
Trás-dir.
Solte.`,
    feel: 'Three distinct directional presses, each with a clear release between. A rotational quality.',
    feel_pt: 'Três pressões direcionais distintas, cada com soltura clara entre. Uma qualidade rotacional.',
    avoid: 'Do not attempt without clear front, back, and lateral awareness. Do not merge steps into a single squeeze.',
    avoid_pt: 'Não tente sem consciência clara de frente, trás e lateral. Não funda passos em um aperto.',
    type: 'alt',
    sets: 15,
    hold: 2,
    relax: 2,
    rest: 0,
    altA: 'Press',
    altA_pt: 'Pressione',
    altB: 'Release',
    altB_pt: 'Solte',
  },

  gentle_push_reset: {
    id: 'gentle_push_reset',
    name: 'Gentle Push Reset',
    name_pt: 'Reset Suave',
    sub: 'After every squeeze set, 3 pushes confirm rest.',
    sub_pt: 'Após cada série de aperto, 3 empurrões confirmam repouso.',
    level: 'Foundation',
    zone: 'Full floor 0-3cm',
    color: '#8A6A7A',
    movement: 'push',
    inst: `After your squeeze set, exhale and gently push the pelvic floor downward. 15% effort. Hold 4 seconds. Release. Repeat 3 times. This confirms the floor returned to true rest.

Picture it: pressing reset on a stopwatch. Three clicks and you are back to zero.`,
    inst_pt: `Após sua série de aperto, expire e empurre suavemente o assoalho para baixo. 15% esforço. Segure 4 segundos. Solte. Repita 3 vezes. Isso confirma repouso real.

Visualize: apertando reset num cronômetro. Três cliques e volta ao zero.`,
    breathe: 'Exhale to push. Inhale to release.',
    breathe_pt: 'Expire para empurrar. Inspire para soltar.',
    timerCue: `Exhale.
Push.
Release.`,
    timerCue_pt: `Expire.
Empurre.
Solte.`,
    feel: 'Gentle downward opening after each squeeze set.',
    feel_pt: 'Abertura suave para baixo após cada série de aperto.',
    avoid: 'Do not skip after squeeze exercises. Do not strain.',
    avoid_pt: 'Não pule após exercícios de aperto. Não force.',
    type: 'hold',
    sets: 15,
    hold: 4,
    relax: 6,
    rest: 0,
  },

  onda: {
    id: 'onda',
    name: 'Onda',
    name_pt: 'Onda',
    sub: 'Front wall. Release. Back wall. Release. Alternate.',
    sub_pt: 'Parede frontal. Solte. Parede posterior. Solte. Alterne.',
    level: 'Intermediate',
    zone: 'Full floor 0-6cm',
    color: '#9A7080',
    movement: 'squeeze',
    inst: `Sit with feet flat on the floor.

Gently press the front wall of the pelvic floor inward for 2 seconds. Release completely.

Gently press the back wall inward for 2 seconds. Release completely.

Alternate front and back in a slow rocking rhythm. Each direction is a separate, deliberate movement with a full release between.

Build toward 1 second per direction as the distinction becomes clear.

Picture it: a seesaw. One side up while the other is down. The front and back walls should feel like two separate entities.`,
    inst_pt: `Sente com pés apoiados no chão.

Pressione suavemente a parede frontal do assoalho por 2 segundos. Solte completamente.

Pressione suavemente a parede posterior por 2 segundos. Solte completamente.

Alterne frente e trás num ritmo lento de balanço. Cada direção é um movimento separado e deliberado com soltura total entre.

Construa para 1 segundo por direção conforme a distinção fica clara.

Visualize: gangorra. Um lado sobe enquanto o outro desce. As paredes frontal e posterior devem parecer duas entidades separadas.`,
    breathe: 'Exhale to press each wall in. Inhale to release between directions.',
    breathe_pt: 'Expire para pressionar cada parede. Inspire para soltar entre direções.',
    timerCue: `Front wall.
Release.
Back wall.
Release.`,
    timerCue_pt: `Parede frontal.
Solte.
Parede posterior.
Solte.`,
    feel: 'Two distinct directions with a clear release between each.',
    feel_pt: 'Duas direções distintas com soltura clara entre cada.',
    avoid: 'Do not squeeze front and back simultaneously. Do not skip the release between directions.',
    avoid_pt: 'Não aperte frente e trás simultaneamente. Não pule a soltura entre direções.',
    type: 'alt',
    sets: 19,
    hold: 2,
    relax: 2,
    rest: 0,
    altA: 'Front wall',
    altA_pt: 'Parede frontal',
    altB: 'Back wall',
    altB_pt: 'Parede posterior',
  },

  ordenha_ascend: {
    id: 'ordenha_ascend',
    name: 'Ordenha Ascending',
    name_pt: 'Ordenha Ascendente',
    sub: 'Level 1. Add Level 2. Add Level 3. Do not skip.',
    sub_pt: 'Nível 1. Adicione Nível 2. Adicione Nível 3. Não pule.',
    level: 'Intermediate',
    zone: 'Full floor 0-10cm',
    color: '#A07080',
    movement: 'squeeze',
    inst: `Sit with feet flat on the floor.

CLOSE and SQUEEZE at Level 1 (the entrance). Hold.

Without releasing Level 1, add Level 2, imagine the contraction moving one floor deeper. Hold both.

Without releasing, add Level 3, the deepest accessible point. Hold all three levels together.

Release completely from base to Level 1. That is one rep.

If Level 3 is not yet clear, stop at Level 2. The depth develops with repetition.

Picture it: an elevator rising one floor at a time. Each level should feel distinct.`,
    inst_pt: `Sente com pés apoiados no chão.

FECHE e APERTE no Nível 1 (a entrada). Segure.

Sem soltar o Nível 1, adicione Nível 2, imagine a contração subindo um andar. Segure ambos.

Sem soltar, adicione Nível 3, o ponto mais profundo acessível. Segure os três níveis.

Solte completamente da base ao Nível 1. Isso é uma repetição.

Se Nível 3 ainda não estiver claro, pare no Nível 2. A profundidade se desenvolve com repetição.

Visualize: elevador subindo um andar de cada vez. Cada nível deve parecer distinto.`,
    breathe: 'Exhale to CLOSE and SQUEEZE at Level 1. Continue exhaling as you layer in Level 2 and Level 3.',
    breathe_pt: 'Expire para FECHAR e APERTAR no Nível 1. Continue expirando conforme adiciona Nível 2 e Nível 3.',
    timerCue: `Level 1.
Add Level 2.
Add Level 3.
Release.`,
    timerCue_pt: `Nível 1.
Adicione Nível 2.
Adicione Nível 3.
Solte.`,
    feel: 'A sequential layering sensation. Like an elevator rising one floor at a time. Each level should feel distinct.',
    feel_pt: 'Uma sensação de camadas sequenciais. Como elevador subindo um andar de cada vez. Cada nível deve parecer distinto.',
    avoid: 'Do not skip levels to reach Level 3. Do not bear down. Do not hold your breath at any level.',
    avoid_pt: 'Não pule níveis para chegar ao Nível 3. Não faça força. Não prenda respiração em nenhum nível.',
    type: 'hold',
    sets: 10,
    hold: 8,
    relax: 8,
    rest: 0,
  },

  standing_squeeze: {
    id: 'standing_squeeze',
    name: 'Standing Squeeze',
    name_pt: 'Aperto em Pé',
    sub: 'Squeeze against gravity. Standing is harder.',
    sub_pt: 'Aperte contra a gravidade. Em pé é mais difícil.',
    level: 'Foundation',
    zone: 'Full floor 0-3cm',
    color: '#8B4A5A',
    movement: 'squeeze',
    inst: `Stand, feet hip-width apart. No wall support.

CLOSE and SQUEEZE at 60% for 5 seconds. Release for 5 seconds.

Standing squeezes are harder because gravity pulls on organs. If you cannot hold 5 seconds standing, reduce to 3.

Picture it: an invisible hand gently lifting your pelvic floor from below while you stand. The hand holds for 5 seconds, then lets go.`,
    inst_pt: `Fique de pé, pés na largura do quadril. Sem apoio.

FECHE e APERTE em 60% por 5 segundos. Solte por 5 segundos.

Apertos em pé são mais difíceis porque gravidade puxa órgãos. Se não conseguir segurar 5 segundos, reduza para 3.

Visualize: uma mão invisível levantando suavemente seu assoalho de baixo enquanto está de pé. A mão segura 5 segundos, depois solta.`,
    breathe: 'Exhale to squeeze. Inhale to release.',
    breathe_pt: 'Expire para apertar. Inspire para soltar.',
    timerCue: `Squeeze.
Hold.
Release.`,
    timerCue_pt: `Aperte.
Segure.
Solte.`,
    feel: 'Lift against gravity. The floor working with more effort to rise upward.',
    feel_pt: 'Elevação contra a gravidade. O assoalho trabalhando com mais esforço para subir.',
    avoid: 'Do not lock knees. Do not hold breath. Do not bear down.',
    avoid_pt: 'Não trave joelhos. Não prenda respiração. Não faça força.',
    type: 'hold',
    sets: 15,
    hold: 5,
    relax: 5,
    rest: 0,
  },

  succao: {
    id: 'succao',
    name: 'Sucção',
    name_pt: 'Sucção',
    sub: 'At the deepest level. Draw the front wall gently inward.',
    sub_pt: 'No nível mais profundo. Puxe a parede frontal suavemente para dentro.',
    level: 'Advanced',
    zone: 'Front wall 6-10cm',
    color: '#9A7080',
    movement: 'squeeze',
    inst: `Sit comfortably. Take a full breath to prepare.

Bring your awareness to the deepest accessible point of the pelvic floor, Level 3. CLOSE and SQUEEZE to establish a Level 3 contraction.

Now isolate the front wall of the canal at this depth. Gently draw it inward and upward, a soft internal suction, not a push. The movement is subtle. Hold.

Release completely from Level 3 downward. Full release.

Picture it: drawing liquid up through a straw, but from the deepest point of the canal.`,
    inst_pt: `Sente confortavelmente. Respire fundo para preparar.

Leve sua consciência ao ponto mais profundo acessível do assoalho, Nível 3. FECHE e APERTE para estabelecer contração no Nível 3.

Agora isole a parede frontal do canal nessa profundidade. Puxe suavemente para dentro e para cima, uma sucção interna suave, não um empurrão. O movimento é sutil. Segure.

Solte completamente do Nível 3 para baixo. Soltura total.

Visualize: puxando líquido por um canudo, mas do ponto mais profundo do canal.`,
    breathe: 'Exhale to CLOSE and SQUEEZE at Level 3. Inhale gently while holding the suction.',
    breathe_pt: 'Expire para FECHAR e APERTAR no Nível 3. Inspire suavemente enquanto segura a sucção.',
    timerCue: `Level 3.
Front wall.
Draw in.
Hold.`,
    timerCue_pt: `Nível 3.
Parede frontal.
Puxe.
Segure.`,
    feel: 'A deep internal pressure or warmth at the front of the pelvic floor. Subtle.',
    feel_pt: 'Uma pressão interna profunda ou calor na frente do assoalho. Sutil.',
    avoid: 'Do not bear down or push outward. Do not attempt before Level 3 is accessible in Ordenha.',
    avoid_pt: 'Não faça força nem empurre para fora. Não tente antes de Nível 3 estar acessível na Ordenha.',
    type: 'hold',
    sets: 8,
    hold: 10,
    relax: 10,
    rest: 0,
  },

  vibracao: {
    id: 'vibracao',
    name: 'Vibração',
    name_pt: 'Vibração',
    sub: 'Pulsação from deeper inside. If depth retreats, stop and reset.',
    sub_pt: 'Pulsação de mais fundo. Se profundidade recuar, pare e reinicie.',
    level: 'Advanced',
    zone: 'Full floor 3-6cm',
    color: '#7A5060',
    movement: 'squeeze',
    inst: `Sit with feet flat on the floor.

Bring your awareness to Level 2, the central zone. Establish your sense of this depth before beginning.

From Level 2, CLOSE and SQUEEZE for 1 second. Release completely from Level 2 for 1 second. Repeat in rhythm.

If you feel the movement retreating to the entrance, stop. Do 3 Gentle Pushes to reset to Level 2. Begin the next set from depth.

After each set: 3 slow Gentle Pushes confirm the floor has returned to Level 2 rest.

Picture it: the same clean on-off rhythm as Pulsação, but felt deeper inside. Like a heartbeat in your center rather than at the surface.`,
    inst_pt: `Sente com pés apoiados no chão.

Leve sua consciência ao Nível 2, a zona central. Estabeleça sua sensação dessa profundidade antes de começar.

Do Nível 2, FECHE e APERTE por 1 segundo. Solte completamente do Nível 2 por 1 segundo. Repita em ritmo.

Se sentir o movimento recuando à entrada, pare. Faça 3 Empurrões Suaves para resetar ao Nível 2. Comece a próxima série da profundidade.

Após cada série: 3 Empurrões Suaves lentos confirmam que o assoalho voltou ao repouso do Nível 2.

Visualize: o mesmo ritmo liga-desliga limpo da Pulsação, mas sentido mais fundo. Como um batimento cardíaco no seu centro em vez da superfície.`,
    breathe: 'Exhale to CLOSE and SQUEEZE at depth. Inhale to release from depth.',
    breathe_pt: 'Expire para FECHAR e APERTAR na profundidade. Inspire para soltar da profundidade.',
    timerCue: `Level 2.
Squeeze.
Release.`,
    timerCue_pt: `Nível 2.
Aperte.
Solte.`,
    feel: 'A clean on-off rhythm felt deeper inside the pelvic floor.',
    feel_pt: 'Um ritmo limpo de liga-desliga sentido mais fundo no assoalho pélvico.',
    avoid: 'Do not continue if depth retreats to Level 1. Stop and reset. Do not bear down.',
    avoid_pt: 'Não continue se profundidade recuar ao Nível 1. Pare e reinicie. Não faça força.',
    type: 'pulse',
    sets: 4,
    rest: 15,
    reps: 15,
    on: 1,
    off: 1,
  },
};

export const days = [
  {
    day: 331, week: 48,
    title: 'Day 331', title_pt: 'Dia 331',
    exercises: [
      { ref: 'standing_squeeze', overrides: {} }, // 150s
      { ref: 'child_pose_release', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 332, week: 48,
    title: 'Day 332', title_pt: 'Dia 332',
    exercises: [
      { ref: 'vibracao', overrides: {"sets": 3} }, // 120s
      { ref: 'standing_squeeze', overrides: {"sets": 10} }, // 100s
      { ref: 'ordenha_ascend', overrides: {"sets": 5} }, // 80s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 333, week: 48,
    title: 'Day 333', title_pt: 'Dia 333',
    exercises: [
      { ref: 'vibracao', overrides: {"sets": 3} }, // 120s
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
      { ref: 'aperto', overrides: {"sets": 5} }, // 75s
    ], // Total: 295s = 4.9 min
  },
  {
    day: 334, week: 48,
    title: 'Day 334', title_pt: 'Dia 334',
    exercises: [
      { ref: 'standing_squeeze', overrides: {} }, // 150s
      { ref: 'gentle_push_reset', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 335, week: 48,
    title: 'Day 335', title_pt: 'Dia 335',
    exercises: [
      { ref: 'standing_squeeze', overrides: {} }, // 150s
      { ref: 'child_pose_release', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 336, week: 48,
    title: 'Day 336', title_pt: 'Dia 336',
    exercises: [
      { ref: 'belly_breath_drop', overrides: {} }, // 150s
      { ref: 'gentle_push_reset', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 337, week: 49,
    title: 'Day 337', title_pt: 'Dia 337',
    exercises: [
      { ref: 'ordenha_ascend', overrides: {"sets": 6} }, // 96s
      { ref: 'belly_breath_drop', overrides: {"sets": 10} }, // 100s
      { ref: 'circular_cw', overrides: {"sets": 26} }, // 104s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 338, week: 49,
    title: 'Day 338', title_pt: 'Dia 338',
    exercises: [
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
      { ref: 'aperto', overrides: {"sets": 7} }, // 105s
      { ref: 'succao', overrides: {"sets": 5} }, // 100s
    ], // Total: 305s = 5.1 min
  },
  {
    day: 339, week: 49,
    title: 'Day 339', title_pt: 'Dia 339',
    exercises: [
      { ref: 'vibracao', overrides: {} }, // 165s
      { ref: 'belly_breath_drop', overrides: {"sets": 14} }, // 140s
    ], // Total: 305s = 5.1 min
  },
  {
    day: 340, week: 49,
    title: 'Day 340', title_pt: 'Dia 340',
    exercises: [
      { ref: 'circular_cw', overrides: {"sets": 38} }, // 152s
      { ref: 'vibracao', overrides: {} }, // 165s
    ], // Total: 317s = 5.3 min
  },
  {
    day: 341, week: 49,
    title: 'Day 341', title_pt: 'Dia 341',
    exercises: [
      { ref: 'belly_breath_drop', overrides: {} }, // 150s
      { ref: 'gentle_push_reset', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 342, week: 49,
    title: 'Day 342', title_pt: 'Dia 342',
    exercises: [
      { ref: 'standing_squeeze', overrides: {} }, // 150s
      { ref: 'succao', overrides: {} }, // 160s
    ], // Total: 310s = 5.2 min
  },
  {
    day: 343, week: 49,
    title: 'Day 343', title_pt: 'Dia 343',
    exercises: [
      { ref: 'standing_squeeze', overrides: {} }, // 150s
      { ref: 'child_pose_release', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 344, week: 50,
    title: 'Day 344', title_pt: 'Dia 344',
    exercises: [
      { ref: 'circular_cw', overrides: {"sets": 25} }, // 100s
      { ref: 'vibracao', overrides: {"sets": 3} }, // 120s
      { ref: 'succao', overrides: {"sets": 4} }, // 80s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 345, week: 50,
    title: 'Day 345', title_pt: 'Dia 345',
    exercises: [
      { ref: 'ordenha_ascend', overrides: {"sets": 9} }, // 144s
      { ref: 'gentle_push_reset', overrides: {"sets": 16} }, // 160s
    ], // Total: 304s = 5.1 min
  },
  {
    day: 346, week: 50,
    title: 'Day 346', title_pt: 'Dia 346',
    exercises: [
      { ref: 'circular_cw', overrides: {"sets": 25} }, // 100s
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
      { ref: 'ordenha_ascend', overrides: {"sets": 6} }, // 96s
    ], // Total: 296s = 4.9 min
  },
  {
    day: 347, week: 50,
    title: 'Day 347', title_pt: 'Dia 347',
    exercises: [
      { ref: 'aperto', overrides: {"sets": 7} }, // 105s
      { ref: 'ordenha_ascend', overrides: {"sets": 6} }, // 96s
      { ref: 'circular_cw', overrides: {"sets": 25} }, // 100s
    ], // Total: 301s = 5.0 min
  },
  {
    day: 348, week: 50,
    title: 'Day 348', title_pt: 'Dia 348',
    exercises: [
      { ref: 'ordenha_ascend', overrides: {"sets": 9} }, // 144s
      { ref: 'standing_squeeze', overrides: {"sets": 16} }, // 160s
    ], // Total: 304s = 5.1 min
  },
  {
    day: 349, week: 50,
    title: 'Day 349', title_pt: 'Dia 349',
    exercises: [
      { ref: 'onda', overrides: {"sets": 25} }, // 100s
      { ref: 'aperto', overrides: {"sets": 7} }, // 105s
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
    ], // Total: 305s = 5.1 min
  },
  {
    day: 350, week: 50,
    title: 'Day 350', title_pt: 'Dia 350',
    exercises: [
      { ref: 'ordenha_ascend', overrides: {"sets": 9} }, // 144s
      { ref: 'vibracao', overrides: {} }, // 165s
    ], // Total: 309s = 5.2 min
  },
  {
    day: 351, week: 51,
    title: 'Day 351', title_pt: 'Dia 351',
    exercises: [
      { ref: 'aperto', overrides: {} }, // 150s
      { ref: 'belly_breath_drop', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 352, week: 51,
    title: 'Day 352', title_pt: 'Dia 352',
    exercises: [
      { ref: 'succao', overrides: {} }, // 160s
      { ref: 'circular_cw', overrides: {"sets": 35} }, // 140s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 353, week: 51,
    title: 'Day 353', title_pt: 'Dia 353',
    exercises: [
      { ref: 'succao', overrides: {} }, // 160s
      { ref: 'vibracao', overrides: {"sets": 3} }, // 120s
    ], // Total: 280s = 4.7 min
  },
  {
    day: 354, week: 51,
    title: 'Day 354', title_pt: 'Dia 354',
    exercises: [
      { ref: 'aperto', overrides: {} }, // 150s
      { ref: 'belly_breath_drop', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 355, week: 51,
    title: 'Day 355', title_pt: 'Dia 355',
    exercises: [
      { ref: 'vibracao', overrides: {"sets": 3} }, // 120s
      { ref: 'standing_squeeze', overrides: {"sets": 10} }, // 100s
      { ref: 'gentle_push_reset', overrides: {"sets": 8} }, // 80s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 356, week: 51,
    title: 'Day 356', title_pt: 'Dia 356',
    exercises: [
      { ref: 'aperto', overrides: {} }, // 150s
      { ref: 'belly_breath_drop', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 357, week: 51,
    title: 'Day 357', title_pt: 'Dia 357',
    exercises: [
      { ref: 'ordenha_ascend', overrides: {"sets": 9} }, // 144s
      { ref: 'aperto', overrides: {} }, // 150s
    ], // Total: 294s = 4.9 min
  },
  {
    day: 358, week: 52,
    title: 'Day 358', title_pt: 'Dia 358',
    exercises: [
      { ref: 'aperto', overrides: {} }, // 150s
      { ref: 'child_pose_release', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 359, week: 52,
    title: 'Day 359', title_pt: 'Dia 359',
    exercises: [
      { ref: 'circular_cw', overrides: {"sets": 38} }, // 152s
      { ref: 'ordenha_ascend', overrides: {"sets": 9} }, // 144s
    ], // Total: 296s = 4.9 min
  },
  {
    day: 360, week: 52,
    title: 'Day 360', title_pt: 'Dia 360',
    exercises: [
      { ref: 'succao', overrides: {} }, // 160s
      { ref: 'onda', overrides: {"sets": 35} }, // 140s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 361, week: 52,
    title: 'Day 361', title_pt: 'Dia 361',
    exercises: [
      { ref: 'ordenha_ascend', overrides: {"sets": 6} }, // 96s
      { ref: 'onda', overrides: {"sets": 25} }, // 100s
      { ref: 'vibracao', overrides: {"sets": 3} }, // 120s
    ], // Total: 316s = 5.3 min
  },
  {
    day: 362, week: 52,
    title: 'Day 362', title_pt: 'Dia 362',
    exercises: [
      { ref: 'vibracao', overrides: {} }, // 165s
      { ref: 'circular_cw', overrides: {"sets": 34} }, // 136s
    ], // Total: 301s = 5.0 min
  },
  {
    day: 363, week: 52,
    title: 'Day 363', title_pt: 'Dia 363',
    exercises: [
      { ref: 'vibracao', overrides: {} }, // 165s
      { ref: 'ordenha_ascend', overrides: {"sets": 8} }, // 128s
    ], // Total: 293s = 4.9 min
  },
  {
    day: 364, week: 52,
    title: 'Day 364', title_pt: 'Dia 364',
    exercises: [
      { ref: 'circular_cw', overrides: {"sets": 38} }, // 152s
      { ref: 'belly_breath_drop', overrides: {} }, // 150s
    ], // Total: 302s = 5.0 min
  },
  {
    day: 365, week: 53,
    title: 'Day 365', title_pt: 'Dia 365',
    exercises: [
      { ref: 'onda', overrides: {"sets": 38} }, // 152s
      { ref: 'aperto', overrides: {} }, // 150s
    ], // Total: 302s = 5.0 min
  },
];

export const milestone = {
  title: 'Month 12 Check-in',
  title_pt: 'Check-in do Mes 12',
  questions: [
    {
      q: 'Do you command all 7 movements?',
      q_pt: 'Voce comanda todos 7 movimentos?',
      yes_response: 'You are on track. Continue to the next month.',
      yes_response_pt: 'Voce esta no caminho. Continue para o proximo mes.',
      no_response: 'Repeat this month for 2 more weeks. If no progress after 6 weeks total, consult a pelvic floor physiotherapist.',
      no_response_pt: 'Repita este mes por mais 2 semanas. Se sem progresso apos 6 semanas, consulte fisioterapeuta de assoalho pelvico.',
    },
  ],
};

export const monthMeta = {
  month: 12,
  program: 'weak_pf',
  phase: 'Mastery Foundation',
  phase_pt: 'Base de Maestria',
  days_range: [331, 365],
  session_target_seconds: 300,
};

export function resolveDay(dayNumber) {
  const dayData = days.find(d => d.day === dayNumber);
  if (!dayData) return null;
  return { ...dayData, exercises: dayData.exercises.map(ex => ({ ...exercises[ex.ref], ...ex.overrides })) };
}